class CartProgress extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Fetch the cart total dynamically from the attribute
    const cartTotal = parseInt(this.getAttribute('cart-total')) || 0;

    // Define the thresholds and titles
    const thresholds = [
      {
        threshold: parseInt(this.getAttribute('data-threshold-1')) || 79,
        title: this.getAttribute('data-title-1'),
      },
      {
        threshold: parseInt(this.getAttribute('data-threshold-2')) || 150,
        title: this.getAttribute('data-title-2'),
      },
      {
        threshold: parseInt(this.getAttribute('data-threshold-3')) || 200,
        title: this.getAttribute('data-title-3'),
      },
    ];

    const maxThreshold = Math.max(...thresholds.map((t) => t.threshold));

    // Get the filled bar element
    const filledBar = this.querySelector('#filled-bar');

    // Calculate and set the width of the progress bar based on the cart total
    const fillPercentage = Math.min((cartTotal / maxThreshold) * 100, 100);
    filledBar.style.width = fillPercentage + '%';

    // Update points based on cart total
    this.querySelectorAll('.point').forEach((point) => {
      const threshold = parseInt(point.getAttribute('data-threshold'));
      if (cartTotal >= threshold) {
        point.classList.add('reached');
      } else {
        point.classList.remove('reached');
      }
    });

    // Update the title in the .progress-title based on the highest threshold reached
    let title = this.getAttribute('data-default-title'); // Start with the default title
    for (let i = 0; i < thresholds.length; i++) {
      if (cartTotal >= thresholds[i].threshold) {
        title = thresholds[i].title; // Override with the highest reached threshold
      }
    }

    // If no threshold has been met, retain the default title
    const titleElement = this.querySelector('.progress-title');
    if (titleElement) {
      titleElement.textContent = title;
    }
  }
}

// Define the new element
customElements.define('cart-progress', CartProgress);
